import React, { useEffect, useState } from 'react'

import { Link, useNavigate, useParams } from 'react-router-dom'
import ApplicationLogo from '../components/ApplicationLogo'
import DynamicForm, { IDynamicForm, IDynamicFormElement, IRequiredField } from '../components/Form/DynamicForm'
import { useDispatch } from 'react-redux'
import { addNewForm, createOrUpdateElementData, updateFormLoading } from '../components/Form/formsSlice'
import GenerateForm from '../components/Form/GenerateForm'
import { LoadingButton } from '@mui/lab'
import { IAxiosDefaultDataObject } from '../config'
import { verifyStrongPassword } from '../features/user/UsersApp'
import UserService from '../services/user'
import { updateQuickNotificationDetails } from '../features/notifications/notificationsSlice'

export default function BlockAccount() {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [loading, setLoading] = useState<boolean>(false)

    const [isSuccess, setIsSuccess] = useState<boolean>(false)

    const elemPrefix: string = "block-account_"
    const form: IDynamicForm = {
        name: "block-account-form",
        elements: [
            {
                id: elemPrefix + "email",
                xs: 12,
                type: "TextField",
                label: "Email",
                fullWidth: true
            },
            {
                id: elemPrefix + "password",
                xs: 12,
                type: "TextField",
                label: "Password",
                fullWidth: true,
                fieldType: "password",
            }
        ]
    }

    const elementsData = DynamicForm.useReturnAllFormsData()
    const singleElemDataValue = (name: string) => DynamicForm.returnSingleFormElementData(elemPrefix + name, elementsData).value

    /**
     * Update loading
     */
    const updateLoading = (status: boolean) => {
        dispatch(updateFormLoading({ formName: form.name, loading: status }))
        setLoading(status)
    }

    /**
     * Create form elem data
     */
    const createFormElemData = () => {
        form.elements.map((elem) => dispatch(createOrUpdateElementData({
            name: elem.id,
            value: ""
        })))
    }

    /**
     * Reset form
     */
    const resetForm = () => {
        createFormElemData()
        DynamicForm.createOrUpdateFormMessage(form.name, { shown: false, type: "success", message: "" }, dispatch)
    }


    /**
     * Handle submit
     */
    const handleSubmit = () => {

        let data: IAxiosDefaultDataObject = {}

        data.email = singleElemDataValue("email")
        data.password = singleElemDataValue("password")

        let requiredFields: IRequiredField[] = [
            {
                id: elemPrefix + "email",
                message: "Email is required"
            },
            {
                id: elemPrefix + "password",
                message: "Password is required"
            },
        ]

        DynamicForm.resetRequiredFieldsHelperText(requiredFields, elementsData, dispatch)
        const verifyForm = DynamicForm.verifyForm(elementsData, requiredFields)

        if (verifyForm.isValid){
            DynamicForm.updateFormLoadingStatus(form.name, true, dispatch)

            UserService.blockAccount(data.email, data.password)
                .then(response => {

                    const { data } = response

                    const message = data.message ? data.message : "Success!"
                    DynamicForm.updateFormLoadingStatus(form.name, false, dispatch)
                    DynamicForm.createOrUpdateFormMessage(form.name, { shown: true, type: "success", message: message }, dispatch)

                    resetForm()
                    updateQuickNotificationDetails(true, message, "success", dispatch)

                    setTimeout(() => navigate("/"), 1500)
                    setIsSuccess(true)

                })
                .catch(error => {

                    console.log(error)
                    const message = error.response.data.message ? error.response.data.message : "Fatal Error"

                    setIsSuccess(false)
                    DynamicForm.updateFormLoadingStatus(form.name, false, dispatch)
                    DynamicForm.createOrUpdateFormMessage(form.name, { shown: true, type: "error", message: message }, dispatch)

                })

        }else{
            DynamicForm.updateRequiredFieldsHelperText(verifyForm.fields, elementsData, dispatch)
        }

    }

    useEffect(() => {
        dispatch(addNewForm(form))
        createFormElemData()
    }, [])


    return(
        <div className="login-page-container">
            <div className="content-of-login-page-container">

                <div className="login-form-box-container">
                    <div className="content-of-login-form-box-container">

                        <div className="logo-box-of-login-form-box-container">
                            <div className="content-of-logo-box-of-login-form-box-container">
                                <ApplicationLogo />
                            </div>
                        </div>

                        <div className="text-box-of-login-form-box-container">
                            <div className="content-of-text-box-of-login-form-box-container">
                                <h2>Block account</h2>
                                <p>If you think your account is compromised, you can block it here</p>
                            </div>
                        </div>

                        <div className="form-of-login-form-box-container">
                            <div className="content-of-form-of-login-form-box-container">
                                <GenerateForm name={form.name} />

                                <div className="submit-button-box-of-login-form">
                                    <LoadingButton onClick={() => handleSubmit()} disabled={isSuccess} className="general-button" loading={loading} variant="contained" fullWidth type="submit">Block</LoadingButton>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>

            </div>
        </div>
    )
}